import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-floorManagement",
  "use": "icon-floorManagement-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-floorManagement\"><path d=\"M819.2 409.6l172.8-96L512 44.8 32 313.6l172.8 96L32 512l166.4 96L32 704l480 275.2L992 704l-166.4-96L992 512 819.2 409.6zM512 115.2l352 198.4L512 512 160 313.6l352-198.4zM268.8 448L512 582.4 755.2 448 864 512 512 716.8 160 512l108.8-64zM864 704L512 908.8 160 704l102.4-57.6L512 787.2 761.6 640 864 704z\" data-spm-anchor-id=\"a313x.search_index.0.i9.7f143a81kaZVkx\" class=\"selected\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol